import React, { useEffect, useState } from "react";
import axios from "axios";

import { Link } from "react-router-dom";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000/";

const MANAGER_ID = 1;

const getToday = () => {
  const date = new Date();

  const year = date.getFullYear();

  const month = String(date.getMonth() + 1).padStart(2, "0");

  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const ManagerPerformanceList = () => {
  const [date, setDate] = useState(getToday());

  const [employees, setEmployees] = useState([]);

  const [loading, setLoading] = useState(false);

  const loadEmployees = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${API}api/Performance/manager/pending`,
        {
          params: {
            manager_id: MANAGER_ID,
            date,
          },
        },
      );

      setEmployees(response.data.data || []);
    } catch (error) {
      console.error(error);

      alert(error.response?.data?.message || "Unable to load performance");
    } finally {
      setLoading(false);
    }
  };
  const Reset_filter = async () => {
    loadEmployees();
  };

  useEffect(() => {
    loadEmployees();
  }, [date]);

  const getStatusClass = (status) => {
    if (status === "Approved") {
      return "status-approved";
    }

    if (status === "Rejected") {
      return "status-rejected";
    }

    return "status-pending";
  };

  return (
    <>
      <div className="page-header">
        <h1>Daily Performance Approval</h1>
        <ul id="breadcrumbs" className="breadcrumb mb00">
          <li>
            <Link to="/dashboard">Dashboard </Link>
          </li>
          <li>
            <Link to="/employeelist">
              <span>/</span>Performance Dashboard{" "}
            </Link>
          </li>
          <li className="current">
            <span>/</span>Performance
          </li>
        </ul>
      </div>
      <div className="row_bg">
        <div className="dash_white_box2 mb20 p20">
          <div className="dash_white_box_ttl">Search</div>
          <div className="row mb10">
            <div className="col-lg-3 col-md-6 pr07">
              <label className="form-label">Review Date</label>
              <input
                type="text"
                className="form-control"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                autoComplete="none"
                placeholder="Search by Date"
              />
              {/* <input type="text" className="form-control" onChange={(e) => setSearchbytext(e.target.value)} value={searchbytext} autoComplete='none' placeholder='Search by name/code' /> */}
            </div>
            <div className="col-lg-3 col-md-6 pr07">
              <label className="h49 mb10"></label>
              <button className="btn btn-success" onClick={Reset_filter}>
                Clear Filter
              </button>
            </div>
          </div>
        </div>
        <div className="dash_white_box2">
          <div className="row mb30">
            <div className="col-md-12">
              <table className="table_style_1">
                <thead>
                  <tr>
                    <th>Employee</th>

                    <th>Code</th>

                    <th>Department</th>

                    <th>Allocation</th>

                    <th>Hours</th>

                    <th>KPI</th>

                    <th>Final</th>

                    <th>Status</th>

                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {loading && (
                    <tr>
                      <td colSpan="9" className="text-center">
                        Loading...
                      </td>
                    </tr>
                  )}

                  {!loading && employees.length === 0 && (
                    <tr>
                      <td colSpan="9" className="text-center">
                        No performance records found
                      </td>
                    </tr>
                  )}

                  {employees.map((employee) => (
                    <tr key={employee.employee_id}>
                      <td>
                        <strong>{employee.employee_name}</strong>
                      </td>

                      <td>{employee.employee_code}</td>

                      <td>{employee.department_name}</td>

                      <td>{employee.allocation_score ?? "-"}%</td>

                      <td>{employee.hours_score ?? "-"}%</td>

                      <td>{employee.kpi_score ?? "-"}%</td>

                      <td>
                        <strong>{employee.final_score ?? "-"}%</strong>
                      </td>

                      <td>
                        <span
                          className={`performance-status ${getStatusClass(
                            employee.status,
                          )}`}
                        >
                          {employee.status}
                        </span>
                      </td>

                      <td>
                        <Link
                          className="btn btn-primary btn-sm"
                          to={`/manager/performance-review/${employee.employee_id}/${date}`}
                        >
                          Review
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManagerPerformanceList;
